import { render, staticRenderFns } from "./IndexHorizontal.vue?vue&type=template&id=f3a6c36a&"
import script from "./IndexHorizontal.vue?vue&type=script&lang=js&"
export * from "./IndexHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./IndexHorizontal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports